import { RoleplaysHeader } from "./RoleplaysHeader";
import { ScenarioAssignmentContent } from "./ScenarioAssignmentContent";

interface RoleplayAssignmentContainerProps {
  pageLoading?: boolean;
}

export function RoleplayAssignmentContainer({
  pageLoading = false,
}: RoleplayAssignmentContainerProps) {
  if (pageLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <RoleplaysHeader />
      <ScenarioAssignmentContent page="roleplayDetail" />
    </>
  );
}
